import { program } from "../mintWrapper";

program.parse(process.argv);
